import { render, staticRenderFns } from "./EditAgendaItem.vue?vue&type=template&id=f86be696&"
import script from "./EditAgendaItem.vue?vue&type=script&lang=js&"
export * from "./EditAgendaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports